type CanvasViewLike = {
  questions?: unknown;
  languages?: unknown[] | null;
  themes?: unknown[] | null;
  meta?: object | null;
};

/** Normalize optional Canvas collection fields at an untrusted wire boundary. */
export function normalizeCanvasView<T extends CanvasViewLike>(canvas: T): T {
  const rawQuestions = canvas.questions;
  const questions =
    Array.isArray(rawQuestions) && rawQuestions.every((item): item is string => typeof item === "string")
      ? rawQuestions
      : [];
  return {
    ...canvas,
    questions,
    languages: canvas.languages ?? [],
    themes: canvas.themes ?? [],
    meta: canvas.meta ?? {},
  } as T;
}
